import { RawLocation } from 'vue-router'
import { downloadFile } from '@/utils/helper'

export interface Callback {
  closeDialog?: boolean // 是否关闭弹窗
  redirect?: RawLocation // 是否要重定向路由
}

/**
 * 处理通知点击后的事件，默认点击后会标记为已读
 * 而这里就是进行额外的处理，例如跳转到 xxx 页面，打开 xxx 提示等
 * @param notify
 * @returns { Promise<Callback> }
 */
export async function handlerClick(notify): Promise<Callback> {
  switch (true) {
    // 流程
    case notify.type.startsWith('flow/padding'):
      // return flowPaddingActions[notify.type] ? flowPaddingActions[notify.type](notify) : {};
      break
    // 附件下载
    case notify.type === 'file/down':
      if (typeof notify.payload === 'string') {
        console.log('notify', notify)
        const fileName = notify.payload.split('/').pop() || ''
        downloadFile(notify.payload, fileName)
        return Promise.resolve({ closeDialog: true })
      }
      break
  }
  return {}
}
